
(function(){
function alignOne(m){
var cols = m.querySelectorAll(':scope > .sjwpp-gcol');
if(!cols.length) return;
// CSS Grid owns the two-column alignment. Measuring a sticky buy column
// while it is stuck can return its scroll-adjusted offset; persisting that
// number as gallery margin makes the gallery jump down after scrolling back.
// Also clears a stale inline value restored from the browser back/forward cache.
cols[0].style.removeProperty('margin-top');
}
function align(){ document.querySelectorAll('.sjwpp-main2').forEach(alignOne); }
function boot(){
align();
if(document.fonts && document.fonts.ready){ document.fonts.ready.then(align); }
setTimeout(align, 400);
setTimeout(align, 1200);
}
if(document.readyState !== 'loading'){ boot(); }
else { document.addEventListener('DOMContentLoaded', boot); }
window.addEventListener('load', align);
window.addEventListener('pageshow', align);
document.addEventListener('shopify:section:load', align);
var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(align, 120); });
})();
